import { Button, Menu, MenuItem } from "@material-ui/core";
import { GetApp as ExportIcon } from "@material-ui/icons";
import {
	ExportServerDOCXButton,
	ExportServerPDFButton,
} from "components/dialogs/ExportDialog/ExportServerButton";
import React from "react";
import { useTranslate } from "react-admin";

export const DownloadPalletsLabelsDropdown = ({ order }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const translate = useTranslate();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<Button
				variant="outlined"
				color="primary"
				size="small"
				onClick={handleClick}
				startIcon={<ExportIcon />}
			>
				{translate("tab.pallets.buttons.all_pallet_labels")}
			</Button>
			<Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
				<MenuItem onClick={handleClose}>
					<ExportServerDOCXButton endpoint={`order/${order.id}/pallets/label`} />
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<ExportServerPDFButton endpoint={`order/${order.id}/pallets/label`} />
				</MenuItem>
			</Menu>
		</div>
	);
};
